import React, { FC } from 'react'
import { CalloutCompoundProps } from './CalloutCompound.types'
import { sanitizeHTML } from '../../../../utils'
import { BrandIcon } from '../BrandIconCompound'

export const CalloutCompound: FC<CalloutCompoundProps> = props => {
  const { title, icon, brandIcon, content, grayBox, hasBorder } = props
  const grayboxContent = grayBox && 'has-graybox'
  const borderClasses = hasBorder && 'border u-border u-borderColorNeutral'
  const grayBoxAndIcon =
    grayBox &&
    icon?.iconImage &&
    !content &&
    'has-icon u-marginTop16 u-sm-paddingVert20 u-posRelative'
  const noIcon = !icon?.iconImage && 'no-icon'
  const contentGrayBoxAndImageCheck =
    grayBox && !icon?.iconImage && !content ? 'u-padding0' : 'u-paddingVert20'
  return (
    <div
      className={`Callout Content u-sizeFull ${grayboxContent} ${borderClasses} ${grayBoxAndIcon} ${noIcon}`}
      data-analytics-compound-name='callout'
    >
      {title && (
        <h2
          className={`u-sm-marginBottom24 u-marginBottom20 ${
            hasBorder ? 'u-paddingTop8 u-paddingHoriz20' : ''
          }`}
          data-analytics-content-heading-name='title'
        >
          {title}
        </h2>
      )}
      <div
        className={`Callout-content u-flex u-flexJustifyBetween u-sm-flexCol u-md-flex u-lg-flex ${contentGrayBoxAndImageCheck} ${
          grayBox ? 'has-graybox u-block' : ''
        }`}
      >
        {icon?.iconImage && !brandIcon?.iconsDropdown && (
          <figure
            className={`Callout-icon Content ${
              grayBox || content ? 'u-sm-size9of12 u-sm-marginBottom16' : ''
            }`}
          >
            <img className='u-sizeFull' src={icon.iconImage} alt={icon.iconAlt} />
          </figure>
        )}
        {brandIcon?.iconsDropdown && (
          <div
            className={`Callout-icon Content ${
              grayBox || content ? 'u-sm-size9of12  u-sm-marginBottom16' : ''
            }`}
          >
            <BrandIcon {...brandIcon} />
          </div>
        )}

        <div
          className={`Callout-text Content u-sizeFull ${
            icon?.iconImage && grayBox ? 'u-sm-paddingHoriz0 u-paddingTop0' : ''
          } ${
            icon?.iconImage || brandIcon?.iconsDropdown ? 'u-paddingLeft40 u-sm-paddingLeft0' : ''
          }
          `}
          data-analytics-content-name='callout-text'
        >
          <div data-analytics-content-name='callout-text-content'>
            {content?.map(item => (
              <div
                key={item.contentBox}
                dangerouslySetInnerHTML={{
                  __html: sanitizeHTML(item.contentBox),
                }}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}
